import React from "react";
import { Grid, Loader } from "semantic-ui-react";
import ExpressListItem from "./ExpressListItem";
import moment from "moment";

const _tvsecContainer = (my) => ({
	backgroundColor: !my ? "#43b39e" : "orange",
	width: "100%",
	position: "relative",
	padding: 10,
	display: "flex",
	borderRadius: "4px 4px 0 0",
	marginTop: "5px",
	boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
	alignItems: "baseline",
});

const ExpressList = ({ loading, list, goToFolderManager, generalParameters }) => {
	if (loading)
		return (
			<div style={{ width: "100%", textAlign: "center" }}>
				<Loader active inline />
			</div>
		);

	return (
		<Grid style={{ width: "100%" }}>
			<Grid.Row key={"appoint"} style={_tvsecContainer(false)}>
				<Grid.Column mobile={16} tablet={16} computer={16} style={{ color: "white" }}>
					<div>
						<b>{list !== undefined && list.length > 0 && list.length + " dossier(s) dépôt express en attente de validation"}</b>
					</div>
				</Grid.Column>
			</Grid.Row>
			{list
				?.slice()
				.sort((a, b) => (a.docsAssociated && a.docsAssociated !== "" ? (b.docsAssociated ? moment(a.created_at) - moment(b.created_at) : -1) : 1))
				.map((l) => {
					return (
						<ExpressListItem
							key={`expressItem-${l.id}`}
							express={l}
							handleOnPress={() => goToFolderManager(l.folder.id)}
							generalParameters={generalParameters}
						/>
					);
				})}
		</Grid>
	);
};

export default ExpressList;
